/*Servicio para filtrar las rutas por todos los parametros requeridos */
/*Operadores, transportes, timpo etc.....*/ 
const WALKING = 'WALKING';
export default {
  
  filterDeselectedOperators(selectedOperators, operatorOptions) {
    const deselectedOperatorIds = [];
    Object.keys(selectedOperators).forEach(operatorKey => {
      if (!selectedOperators[operatorKey]) {
        const operator = operatorOptions.find(option => option.value === operatorKey);
        if (operator) {
          deselectedOperatorIds.push(operator.id);
        }
      }
    });
    return deselectedOperatorIds;
  },

  filterRouteByAgencyId(response, deselectedOperatorIds) {
    const filteredRoutes = response.routes.filter(route => {
      const hasInvalidStep = route.leg.steps.some(step => {
        return deselectedOperatorIds.includes(step.agencyId);
      });
      return !hasInvalidStep;
    });
    return {
      ...response,
      routes: filteredRoutes
    };
  },

  filterRoutesBySelectedOperators(response, selectedOperators, operatorOptions) {
    const deselectedOperatorIds = this.filterDeselectedOperators(selectedOperators, operatorOptions)
    const valenBisiOption = operatorOptions.find(option => (
      option.id === '-' || String(option.value).replace(/[-\s]/g, '').toUpperCase() === 'VALENBISI'
    ))
    const valenBisiKey = valenBisiOption?.value || Object.keys(selectedOperators).find(key => (
      key.replace(/[-\s]/g, '').toUpperCase() === 'VALENBISI'
    ))
    const valenBisiSelected = !valenBisiKey || selectedOperators[valenBisiKey] !== false

    return {
      ...response,
      routes: response.routes.filter(route => !route.leg.steps.some(step => {
        const hasDeselectedAgency = deselectedOperatorIds.includes(step.agencyId)
        const isRentedBike = step.mode === 'BICYCLE_RENT' ||
          (step.mode === 'BICYCLE' && step.rentedBike === true)

        return hasDeselectedAgency || (!valenBisiSelected && isRentedBike)
      }))
    }
  },

  filterRoutesByWalkingTime(response, maxWalkingTimeInMinutes) {
    const maxWalkingTimeInSeconds = maxWalkingTimeInMinutes * 60;
    if (!maxWalkingTimeInMinutes) {
      return response;
    }
    const filteredRoutes = response.routes.filter(route => {
      return route.leg.steps.every(step => {
        if (step.travel_mode === 'WALKING') {
          const walkingTimeInSeconds = step.duration.value;
          if (walkingTimeInSeconds > maxWalkingTimeInSeconds) {
            return false;
          }
        }
        return true;
      });
    });
    return {
      ...response,
      routes: filteredRoutes
    };
  },

  processRoutesForModes(routesObject, selectedTransports) {
    const finalRoutes = [];
    const routes = Array.isArray(routesObject.routes) ? routesObject : routesObject.routes || { routes: [] };

      // Filtrar rutas duplicadas
    const filteredRoutes = this.filterDuplicateRoutes(routes);
      // Organizamos por tiempo
    const sortedRoutesObject = this.sortRoutesByDate(filteredRoutes);

    sortedRoutesObject.routes.forEach(route => {
        // Verificamos si esta ruta tiene un tramo con modo CAR dentro de leg.step
      const hasCarMode = route.leg.steps.some(step => step.mode === 'CAR');
      if (hasCarMode) {
          // Si solo está seleccionado MOTORCYCLE, reemplazamos CAR con MOTORCYCLE
        if (!selectedTransports.CAR && selectedTransports.MOTORCYCLE && !selectedTransports.TAXI) {
          const motorcycleRoute = JSON.parse(JSON.stringify(route));
          motorcycleRoute.leg.steps = motorcycleRoute.leg.steps.map(step => ({
            ...step,
            mode: step.mode === 'CAR' ? 'MOTORCYCLE' : step.mode,
          }));
          finalRoutes.push(motorcycleRoute);
          // Si solo está seleccionado TAXI, reemplazamos CAR con TAXI
        } else if (!selectedTransports.CAR && !selectedTransports.MOTORCYCLE && selectedTransports.TAXI) {
          const taxiRoute = JSON.parse(JSON.stringify(route));
          taxiRoute.leg.steps = taxiRoute.leg.steps.map(step => ({
            ...step,
            mode: step.mode === 'CAR' ? 'TAXI' : step.mode,
          }));
          finalRoutes.push(taxiRoute);
        } else if (!selectedTransports.CAR && selectedTransports.MOTORCYCLE && selectedTransports.TAXI) {
          const motorcycleRoute = JSON.parse(JSON.stringify(route));
          motorcycleRoute.leg.steps = motorcycleRoute.leg.steps.map(step => ({
            ...step,
            mode: step.mode === 'CAR' ? 'MOTORCYCLE' : step.mode,
          }));
          finalRoutes.push(motorcycleRoute);

          const taxiRoute = JSON.parse(JSON.stringify(route));
          taxiRoute.leg.steps = taxiRoute.leg.steps.map(step => ({
            ...step,
            mode: step.mode === 'CAR' ? 'TAXI' : step.mode,
          }));
          finalRoutes.push(taxiRoute);
          // Si CAR está seleccionado, dejamos la ruta original con CAR y duplicamos según los otros modos seleccionados
        } else {
          finalRoutes.push(route);
          if (selectedTransports.MOTORCYCLE) {
            const motorcycleRoute = JSON.parse(JSON.stringify(route));
            motorcycleRoute.leg.steps = motorcycleRoute.leg.steps.map(step => ({
              ...step,
              mode: step.mode === 'CAR' ? 'MOTORCYCLE' : step.mode,
            }));
            finalRoutes.push(motorcycleRoute);
          }
          if (selectedTransports.TAXI) {
            const taxiRoute = JSON.parse(JSON.stringify(route));
            taxiRoute.leg.steps = taxiRoute.leg.steps.map(step => ({
              ...step,
              mode: step.mode === 'CAR' ? 'TAXI' : step.mode,
            }));
            finalRoutes.push(taxiRoute);
          }
        }
      } else {
          // Si no tiene CAR, agregamos la ruta tal cual
        finalRoutes.push(route);
      }
    });
      // Retornamos las rutas en la estructura correcta
    return { routes: finalRoutes };
  },


  filterDuplicateRoutes(routesObject) {
    const seen = new Map(); // Usamos un mapa para rastrear rutas únicas

    const filteredRoutes = routesObject.routes.filter(route => {
        const isWalking = route.leg.steps.every(step => step.travel_mode === WALKING); // Verifica si es solo "WALKING"
        if (isWalking) {
            // Usamos `leg.departure_time.text` y `leg.arrival_time.text` para generar la clave
            const routeKey = `${route.leg.departure_time.text}-${route.leg.arrival_time.text}`;
            if (seen.has(routeKey)) {
                return false; // Ya existe, no lo incluye en el filtrado
            }
            seen.set(routeKey, true); // Marca la ruta como vista
        }
        return true; // Incluye rutas que no son solo "WALKING"
    });

    // Devuelve un objeto con el mismo formato de entrada
    return {
      ...routesObject,
      routes: filteredRoutes, 
    };
  },

  sortRoutesByDate(routesObject) {
    // Crea una copia de las rutas para evitar modificar el objeto original
    const sortedRoutes = [...routesObject.routes];

    // Ordena las rutas por el valor de departure_time.text
    sortedRoutes.sort((a, b) => {
        // Convierte los textos de departure_time a fechas utilizables
        const timeA = new Date(a.leg.departure_time.text); // Convierte el texto a un objeto Date
        const timeB = new Date(b.leg.departure_time.text); // Convierte el texto a un objeto Date
        return timeA - timeB; // Orden ascendente: menor tiempo primero
    });

    // Devuelve un nuevo objeto con las rutas ordenadas
    return {
      ...routesObject,
      routes: sortedRoutes,
    };
  }

}
